import { render, staticRenderFns } from "./xeHistoryRangeSetting.vue?vue&type=template&id=5455ff7b"
import script from "./xeHistoryRangeSetting.vue?vue&type=script&lang=js"
export * from "./xeHistoryRangeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports